import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const menuItem: SxStyleFunc<boolean> = (disabled) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderTopWidth: '1px',
  gap: (p) => p.spacing(1),
  borderTopColor: (p) => p.palette.grey[300],
  borderTopStyle: 'solid',
  mx: (p) => p.spacing(0.5),
  border: 'none',
  svg: {
    color: (p) => p.palette.grey[500],
  },
  opacity: disabled ? 0.5 : 1,
  cursor: disabled ? 'not-allowed' : 'pointer',
});
